import { IThanhPhanThiActionTypes } from "../../action-types/category/IThanhPhanThiActions";
import { IThanhPhanThiReducer } from "../../reducer-model/category/IThanhPhanThiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState  : IThanhPhanThiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    thanhPhanThis: [],
};

export const thanhPhanThiReducer = (
    state: IThanhPhanThiReducer = iniState,
    action: IThanhPhanThiActionTypes
): IThanhPhanThiReducer => {
    switch (action.type) {
        case "THANH_PHAN_THI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "THANH_PHAN_THI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thanhPhanThis: action.payload,
            };
        case "THANH_PHAN_THI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "THANH_PHAN_THI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                thanhPhanThiEditing: action.payload
            };
        case "THANH_PHAN_THI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "THANH_PHAN_THI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "THANH_PHAN_THI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false
            };
        case "THANH_PHAN_THI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "THANH_PHAN_THI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "THANH_PHAN_THI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "THANH_PHAN_THI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}